<template>
  <v-autocomplete
    v-if="selectOptions.length > 0"
    ref="stbMultiSelect"
    v-model="selectedValue"
    class="stb-multi-select"
    :items="selectOptions"
    :disabled="disabled"
    :placeholder="placeholder"
    :custom-filter="searchWithSubheaders"
    color="primary"
    density="compact"
    variant="solo"
    bg-color="grey-lighten-4"
    return-object
    @update:model-value="onSelectChange"
  >
    <template #item="{ item, props }">
      <v-list-subheader
        v-if="item.raw.type === 'subheader'"
        color="primary"
        class="font-weight-bold border-b-sm border-t-sm bg-grey-lighten-4"
      >
        {{ item.raw.title }}
      </v-list-subheader>
      <v-list-item v-else v-bind="props" :disabled="getDisabledState(item)" />
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'StbMultiSelect',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select an Option'
    },
    selectOptions: {
      type: Array,
      default: () => []
    },
    getDisabledState: {
      type: Function,
      default: () => () => false
    }
  },

  emits: ['stbMultiSelectChange'],

  data() {
    return {
      selectedValue: null
    };
  },

  methods: {
    searchWithSubheaders(value, query, item) {
      if (item.raw.type === 'subheader') {
        const subheaderItems = this.selectOptions.filter(
          (option) => !option.type && option.subRiskType === value
        );
        return subheaderItems.some((subItem) =>
          subItem.title.toLowerCase().includes(query.toLowerCase())
        );
      }

      return value.toLowerCase().includes(query.toLowerCase());
    },
    onSelectChange(data) {
      if (data) {
        this.selectedValue = null;
        this.$emit('stbMultiSelectChange', data);
        this.$refs.stbMultiSelect.blur();
      }
    }
  }
};
</script>

<style scoped>
.stb-multi-select :deep(.v-field__input),
.stb-multi-select :deep(.v-field__input input) {
  cursor: pointer !important;
}

.stb-multi-select :deep(input::placeholder) {
  font-size: 14px;
  color: #000000;
  font-weight: 500;
  opacity: 0.7;
}
</style>
